import { Fragment } from "react";
import ProductCard from "@/components/ProductCard";
import type { PromoBannerProps } from "@/components/PromoBanner/types";
import { FormatSubType } from "@/constants/tagular/main";
import { ProductCardProps } from "@/components/ProductCard/types";
import { getLevel } from "../../utils/getLevel";
import SearchHitsPromoBanner from "../SearchHitsPromoBanner";
import type { InlineFypConfig } from "./types";
import useInlineRowPosition from "./useInlineRowPosition";
import InlineFypBlock from "./InlineFypBlock";

interface SearchHitsProps {
  hits: ProductCardProps[];
  results: any;
  facetForLink?: string;
  level?: string;
  promoBannerData?: PromoBannerProps;
  cardClassName?: string | undefined;
  inlineFypConfig?: InlineFypConfig;
}

function SearchHits({
  hits,
  facetForLink = "",
  level = "first",
  promoBannerData,
  cardClassName,
  inlineFypConfig,
}: SearchHitsProps) {
  const inlinePosition = useInlineRowPosition(inlineFypConfig?.afterRow ?? 0);

  return (
    <>
      {hits.map((hit, i) => (
        <Fragment key={hit.uuid}>
          <div className="flex justify-center">
            <ProductCard
              {...hit}
              className={cardClassName || (facetForLink ? "" : "w-full")}
              location="search-results"
              formatSubtype={FormatSubType.HorizontallyStacked}
              resultLevel={getLevel(level) || undefined}
            />
          </div>
          {promoBannerData && i <= 3 && (
            <SearchHitsPromoBanner
              data={promoBannerData}
              position={i}
              level={level}
            />
          )}
          {inlineFypConfig && (
            <InlineFypBlock
              config={inlineFypConfig}
              inlinePosition={inlinePosition}
              currentIndex={i}
            />
          )}
        </Fragment>
      ))}
    </>
  );
}

export default SearchHits;
